import type { SVGProps } from "react";

function LinkedinIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fillRule="evenodd"
      height="25"
      viewBox="0 0 25 25"
      width="25"
      {...props}
    >
      <path
        d="M23.19 1.64c0-.9-.73-1.63-1.63-1.63H1.63C.73.01 0 .74 0 1.64v19.93c0 .9.73 1.63 1.63 1.63h19.93c.9 0 1.63-.73 1.63-1.63V1.64zM3.31 5.65c-.01-.52.19-1.01.56-1.37a2 2 0 011.46-.54c.52-.03 1.04.17 1.42.53.38.38.58.9.56 1.43.01.5-.19.98-.55 1.33-.4.38-.92.57-1.47.55h-.01A1.88 1.88 0 013.3 5.65zm.21 14.06V9.03h3.55v10.68H3.52zm5.51 0h3.55v-5.96c-.04-.7.26-1.36.8-1.78.33-.26.74-.4 1.15-.38 1.2 0 1.79.8 1.79 2.41v5.71h3.55v-6.12c.1-1.3-.3-2.58-1.12-3.59a3.82 3.82 0 00-2.96-1.22 3.63 3.63 0 00-3.2 1.77v.04h-.02l.01-.04V9.04H9.03c.03.34.04 1.4.04 3.18 0 1.77-.01 4.27-.04 7.49z"
        fill="currentColor"
      />
    </svg>
  );
}

export default LinkedinIcon;
